<template>
  <b-row class="mt-4">
    <b-col md="3" sm="6" xs="12" class="mb-3">
      <div class="summary-card">
        <div class="card-icon bg-primary">
          <i class="fa fa-briefcase"></i>
        </div>
        <div class="card-content">
          <h4>{{ summaryData.totalLeads || 0 }}</h4>
          <p>Total Leads</p>
        </div>
      </div>
    </b-col>
    <b-col md="3" sm="6" xs="12" class="mb-3">
      <div class="summary-card">
        <div class="card-icon bg-success">
          <i class="fa fa-check-circle"></i>
        </div>
        <div class="card-content">
          <h4>{{ summaryData.convertedLeads || 0 }}</h4>
          <p>Converted Leads</p>
        </div>
      </div>
    </b-col>
    <b-col md="3" sm="6" xs="12" class="mb-3">
      <div class="summary-card">
        <div class="card-icon bg-warning">
          <i class="fa fa-clock-o"></i>
        </div>
        <div class="card-content">
          <h4>{{ summaryData.pendingLeads || 0 }}</h4>
          <p>Pending Leads</p>
        </div>
      </div>
    </b-col>
    <b-col md="3" sm="6" xs="12" class="mb-3">
      <div class="summary-card">
        <div class="card-icon bg-info">
          <i class="fa fa-dollar"></i>
        </div>
        <div class="card-content">
          <h4>{{ formatCurrency(summaryData.totalRevenue || 0) }}</h4>
          <p>Total Revenue</p>
        </div>
      </div>
    </b-col>
    <b-col md="3" sm="6" xs="12" class="mb-3">
      <div class="summary-card">
        <div class="card-icon bg-danger">
          <i class="fa fa-file-text"></i>
        </div>
        <div class="card-content">
          <h4>{{ summaryData.totalQuotations || 0 }}</h4>
          <p>Total Quotations</p>
        </div>
      </div>
    </b-col>
    <b-col md="3" sm="6" xs="12" class="mb-3">
      <div class="summary-card">
        <div class="card-icon bg-secondary">
          <i class="fa fa-shopping-cart"></i>
        </div>
        <div class="card-content">
          <h4>{{ (summaryData.usedBookings || 0) + '/' + (summaryData.totalBookings || 0) }}</h4>
          <p>Used/Total Bookings</p>
        </div>
      </div>
    </b-col>
    <b-col md="3" sm="6" xs="12" class="mb-3">
      <div class="summary-card">
        <div class="card-icon bg-success">
          <i class="fa fa-percent"></i>
        </div>
        <div class="card-content">
          <h4>{{ summaryData.assignmentRate || 0 }}</h4>
          <p>Total Assignments</p>
        </div>
      </div>
    </b-col>
    <b-col md="3" sm="6" xs="12" class="mb-3">
      <div class="summary-card">
        <div class="card-icon bg-primary">
          <i class="fa fa-users"></i>
        </div>
        <div class="card-content">
          <h4>{{ summaryData.activeClients || 0 }}</h4>
          <p>Active Clients (90d)</p>
        </div>
      </div>
    </b-col>
    <b-col md="3" sm="6" xs="12" class="mb-3">
      <div class="summary-card">
        <div class="card-icon bg-warning">
          <i class="fa fa-money"></i>
        </div>
        <div class="card-content">
          <h4>{{ formatCurrency(summaryData.outstandingAmount || 0) }}</h4>
          <p>Outstanding Amount</p>
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import moment from "moment";

export default {
  name: "SummaryCards",
  props: {
    summaryData: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  methods: {
    formatCurrency(value) {
      if (!value) return "₹0";
      return "₹" + value.toLocaleString("en-IN");
    },
  },
};
</script>

<style scoped>
.summary-card {
  display: flex;
  align-items: center;
  padding: 20px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s;
}

.summary-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.card-icon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
  font-size: 24px;
  color: white;
}

.card-content h4 {
  margin: 0;
  font-size: 28px;
  font-weight: 600;
  color: #2c3e50;
}

.card-content p {
  margin: 5px 0 0 0;
  font-size: 14px;
  color: #7f8c8d;
}

@media (max-width: 768px) {
  .summary-card {
    margin-bottom: 15px;
  }

  .card-icon {
    width: 50px;
    height: 50px;
    font-size: 20px;
    margin-right: 15px;
  }

  .card-content h4 {
    font-size: 24px;
  }

  .card-content p {
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// SummaryCards.vue?4db25df3